const settings = {
  bank_settlement: {
    name: 'Bank name',
    acc: {
      label: 'Account name',
      value: 'Enter account name'
    },
    branch: 'Branch name',
    transfer: 'Bank transfer',
    momo: 'Mobile money transfer',
    num: 'Account Number',
    add: 'Add account',
    edit: 'Edit account',
    title: 'Settlement bank account',
    empty_info: 'You need to set up settlement bank account for your business. This will enable us settle you when the time is due',
    modified: 'Bank details edited successfully',
    created: 'Bank details added successfully'
  },
  cashback: {
    cashback: 'Cashback',
    bname: 'Branch name',
    add: 'Add cashback',
    view: 'View cashback',
    select: 'Select branch',
    fixed: 'Has fixed bonus',
    start: 'Start amount',
    end: 'End amount',
    bonus: 'Bonus',
    empty: 'No cashbacks added. Please add cashback to any branch of your choice',
    percentage: 'Bonus percentage',
    fixed_bonus: 'Fixed bonus',
    edit: 'Edit cashback',
    delete: 'Delete branch',
    delete_msg: 'Cashback deleted successfully',
    details_title: 'Cashback details',
    created: 'Cashback created successfully',
    is_fixed:'Is fixed',
    branch:'Branch'
  },
  contact: {
    header: 'Contact person info',
    save:'Save'
  },
  account_settings: {
    current_pwd: {
      label: 'Current password',
      placeholder: 'Type in your current password'
    },
    new_pwd: {
      label: 'New password',
      placeholder: 'Type in your new password'
    },
    confirm_pwd: {
      label: 'Confirm password',
      placeholder: 'Re-type new password'
    },
    settings: 'Account settings',
    change_pwd: 'Change password'
  },
  role_management: {
    add_role: 'Add role',
    edit: 'Edit role',
    delete: 'Delete branch',
    edit_msg: 'Role modified successfully',
    success_msg: 'Role created successfully',
    delete_msg: 'Role deleted successfully',
    name: {
      name: 'Role name',
      label: 'Enter role name',
    },
    display_name: {
      name: 'Display name',
      label: 'Enter role diplay name',
    }
  },
  permission: {
    label: 'Role name'
  },
  business_info: {
    title: 'Business Information',
    category_id: 'Business category',
    description: {
      label: 'Business description',
      placeholder: 'Describe your business',
    },
    website: {
      label: 'Business website',
      placeholder: 'Enter your business website URL'
    },
  },
  head_office: {
    title: 'Head office address',
    country_id: 'Country',
    state_id: 'State',
    town: {
      label: 'Town',
      placeholder: 'Enter name of town',
    },
    street: {
      label: 'Street name',
      placeholder: 'Enter name of street'
    },
    building: {
      label: 'Building',
      placeholder: 'Enter name of office building'
    },
    address: {
      label: 'Address description',
      placeholder: 'Describe your address'
    },
    location_url: {
      label: 'Location URL',
      placeholder: 'Enter the google map url for your merchant office '
    }
  },
  business_logo: {
    title: 'Upload business logo',
    label: {
      1: 'We recommend your upload should be a ',
      2: 'square dimensions ',
      3: 'eg. 100px X 100px or 1080 X 1080. It must be either jpg or png'
    },
    btn_text: 'Upload file'
  },
  social_media: {
    title: 'Social media',
    btn_text: 'Add link'
  },
  branch: {
    add: 'Add branch',
    edit: 'Edit branch',
    delete: 'Delete branch',
    empty: 'No branch added. Please click add branch button to add new branch',

    table: {
      title: 'Branch management',
      header: {
        location: 'Location',
        name: 'Branch name',
        url: 'Location URL'
      }
    },
    form: {
      name: {
        placeholder: 'Enter branch name'
      },
      location: {
        label: 'Location',
        placeholder: 'Enter branch location'
      },
      address: {
        label: 'Address',
        placeholder: 'Enter branch address'
      },
      opens_at: {
        label: 'Opening time',
      },
      closes_at: {
        label: 'Closing time',
      },
      success: 'Branch created successfully',
      delete_success: 'Branch deleted successfully'
    }
  },
  user_management: {
    table_title: 'User management',
    empty: 'No team members added. Please add team members and set their roles',
    add: 'Add team member',
    add_account: 'Add member',
    edit: 'Edit {{firstname}}\'s details',
    roles: 'Roles',
    form: {
      firstname: {
        label: 'Firstname',
        placeholder: 'Enter your firstname'
      },
      lastname: {
        label: 'Lastname',
        placeholder: 'Enter your lastname'
      },
      phone: {
        label: 'Phone number',
        placeholder: 'Enter your phone number'
      },
      email: {
        label: 'Email address',
        placeholder: 'Enter your email address'
      },
      success: 'User created successfully',
      mod_success: 'User created successfully',
      ban: {
        text: 'Block',
        prompt: 'Do you want to block {{fullname}}?',
        successMsg: '{{fullname}} blocked successfully',
        title: 'Block {{fullname}}'
      },
      activate: {
        text: 'Activate',
        prompt: 'Do you want to activate {{fullname}}?',
        successMsg: '{{fullname}} activated successfully',
        title: 'Activate {{fullname}}'
      }
    }
  },
  schedules: {
    table: {
      day: 'Promo days',
      from: 'Promo start time',
      to: 'Promo end time',
    }
  },
  nav: {
    business: 'Business info',
    bank: 'Settlement info',
    contact: 'Contact person',
    user: 'User management',
    pos: 'POS management',
    role: 'Role managment',
    permission: 'Permission management',
    settings: 'Account settings',
    branches: 'Branches',
    categories: 'Categories',
    schedules: 'Schedules',
    payment_method: 'Payment Method',
  }
};

export default settings;